const STRIPE_PUBLISH_KEY = 'pk_live_qY3OVz0Fgo95r5UL6COIkP4Y';
// const STRIPE_PUBLISH_KEY = 'pk_test_7oKpkFYOepiF0KzqGiHsZ4va';
const INSTA_ACCESSTOKEN = process.env.REACT_APP_INSTA_ACCESSTOKEN || '';
const PAYPAL_CLIENT_ID = 'AeLZdVVYErQtCdA3XcV78ZNtY4xddRgnyrebVh_zBj32rnEVTH7uGd3OixnMwiBRp3AcxcVx9c0mvX7z'
export {
    STRIPE_PUBLISH_KEY,
    INSTA_ACCESSTOKEN,
    PAYPAL_CLIENT_ID
}